import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import ReactFullpage from '@fullpage/react-fullpage';
import { FacebookProvider, Page } from 'react-facebook';
import { BrowserView, MobileView, isBrowser, isMobile, isSafari } from 'react-device-detect';
import { browserName, CustomView } from 'react-device-detect';
import styles from '../../assets/scss/modules/landing.module.scss';
import twitter from "../../assets/media/images/Twitter.png";
import tiktok from "../../assets/media/images/Tiktok.png";
import instagram from "../../assets/media/images/Instagram.png";
import facebook from "../../assets/media/images/Facebook.png";
import jogasz from "../../assets/media/images/jogasz.png";
import kepviselo from "../../assets/media/images/kepviselo.png";
import csalad from "../../assets/media/images/csalad.png";
import asset1 from "../../assets/media/images/asset1.png";
import asset2 from "../../assets/media/images/asset2.png";
import asset3 from "../../assets/media/images/asset3.png";
import asset4 from "../../assets/media/images/asset4.png";
import erikfoto from "../../assets/media/images/profil.png";
import Footer from "../Footer/Footer";




import{
	MDBContainer,
	MDBRow,
	MDBCol,
	MDBCard,
	MDBCardHeader,
	MDBCardBody,
  MDBBtn,
} from 'mdbreact';

class LandingPageDesktop extends Component {
	constructor(props) {
	    super(props);
	    this.state = {
										};

	  };





  render() {
		const anchors = ["home", "program", "kontakt"];
    return (
			<>
			<ReactFullpage
		    licenseKey = {'2C01A6F9-2F35483E-81C14CF4-C7FF7A52'}
		    scrollingSpeed = {500}
				anchors={anchors}
				menu='#myMenu'
				navigation={true}
				navigationPosition={'right'}
				showActiveTooltip= {true}
				responsiveWidth={1000}
				responsiveHeight={740}
		    render={({ state, fullpageApi }) => {
	      return (
					<>
		        <ReactFullpage.Wrapper>
							<MDBContainer fluid className="section fluid-container">
								<div className={styles.bodywrapper}>
								<img className="erik-foto" src={erikfoto}></img>
									<MDBRow className="m-0">
	                  <MDBCol md="7" lg="8" className="pt-1" style={{minHeight: "740px"}}>
	                  <MDBContainer className="padding-container">
	                    <MDBRow className="m-0 respo-row-terseg">
	                      <MDBCol md="1" lg="1" size="2" className="text-left p-0">
													<Link to="/ProgramokBaj">
		                        <span className="baj">BAJ</span>
													</Link>
	                      </MDBCol>
	                      <MDBCol md="2" lg="3" size="2" className="text-center p-0">
													<Link to="/ProgramokSzarliget">
		                        <span className="szarliget">SZÁRLIGET</span>
													</Link>
	                      </MDBCol>
	                      <MDBCol md="1" lg="1" size="2" className="text-center p-0">
													<Link to="/ProgramokTata">
		                        <span className="tata">TATA</span>
													</Link>
	                      </MDBCol>
	                      <MDBCol md="3" lg="3" size="2" className="text-center p-0">
													<Link to="/ProgramokTatabanya">
		                        <span className="tatabanya">TATABÁNYA</span>
													</Link>
	                      </MDBCol>
	                      <MDBCol md="5" lg="4" size="2" className="text-left p-0">
													<Link to="/ProgramokVertesszolos">
		                        <span className="vertesszolos">VÉRTESSZŐLŐS</span>
													</Link>
	                      </MDBCol>
	                    </MDBRow>
	                    <MDBRow className="padding-top-kisgyermekes-apaken">
	                     <span className="kisgyermekes-apaken">“Kisgyermekes apaként európai, fenntartható jövőt akarok nemcsak magunknak, hanem gyermekeinknek is. Itthon képzeljék el jövőjüket, lehessenek ismét büszkék hazánkra, és bizakodással tekinthessenek a jövőbe!”</span>
	                    </MDBRow>
	                    <MDBRow className="pt-4">
											<MDBCol md="auto">
	                      <a 	href="https://actionnetwork.org/forms/legyel-a-dk-aktivistaja/?fbclid=IwAR3BHfOSTA7n7UMN6HVcdgxwGGa5aT28mNVoIVowEcldfOzsbVwOYSpwk-o"
	            							target="_blank" rel="noopener noreferrer">
	                          <MDBBtn
	                              className="csatlakozom-btn-landing"
	                              type="btn"
	                              >
	                              CSATLAKOZZ!
	                          </MDBBtn>
	            					</a>
											</MDBCol>
											<MDBCol md="auto">
	                      
											</MDBCol>
	                    </MDBRow>
	                    </MDBContainer>
	                  </MDBCol>
	                  <MDBCol md="5" lg="4" className="pr-3 text-right">
	                  </MDBCol>
	                </MDBRow>
								</div>
							</MDBContainer>
		          <MDBContainer fluid className="section fluid-container">
								<div className={styles.bodywrapper2}>
									<MDBRow className="m-0">
	                  <MDBCol md="5" className="p-0">
	                    <MDBRow>
	                    <img className="asset1-size" src={asset1}></img>
	                    </MDBRow>
	                    <MDBRow center className="row-programok-padding-respo">
		                    <MDBCol md="6" middle className="text-center pb-2 pt-3 pr-0">
		                      <Link to="/MindannyiunkHangja">
		                        <MDBBtn
		                            className="programok-btn-landing"
		                            type="btn"
		                            >
		                            MINDANNYIUNK HANGJA
		                        </MDBBtn>
		                      </Link>
		                    </MDBCol>
												<MDBCol md="6" middle className="text-center pb-2 pt-3 pl-0">
		                      <Link to="/OktatasMunkaVilaga">
		                        <MDBBtn
		                            className="programok-btn-landing"
		                            type="btn"
		                            >
		                            AZ OKTATÁS ÉS MUNKA VILÁGA
		                        </MDBBtn>
		                      </Link>
		                    </MDBCol>
	                    </MDBRow>
	                    <MDBRow center>
		                    <MDBCol md="6" middle className="text-center pb-2 pt-2 pr-0">
		                      <Link to="/Kozegeszsegugy">
		                        <MDBBtn
		                            className="programok-btn-landing"
		                            type="btn"
		                            >
		                            A KÖZEGÉSZSÉGÜGY MEGGYÓGYÍTÁSA
		                        </MDBBtn>
		                      </Link>
		                    </MDBCol>
												<MDBCol md="6" middle className="text-center pb-2 pt-2 pl-0">
												 <Link to="/LakhatasLakasfenntartas">
													 <MDBBtn
															 className="programok-btn-landing"
															 type="btn"
															 >
															 LAKHATÁS, LAKÁSFENNTARTÁS
													 </MDBBtn>
												 </Link>
											 </MDBCol>
                     </MDBRow>
                     <MDBRow center>
	                    <MDBCol md="6" middle className="text-center pb-2 pt-2 pr-0">
												<Link to="/KornyezetunkMegovasa">
													<MDBBtn
															className="programok-btn-landing"
															type="btn"
															>
															KÖRNYEZETÜNK MEGÓVÁSA
													</MDBBtn>
												</Link>
	                    </MDBCol>
											<MDBCol md="6" middle className="text-center pb-2 pt-2 pl-0">
												<Link to="/EpitettTermeszetiOrokseg">
													<MDBBtn
															className="programok-btn-landing"
															type="btn"
															>
															ÉPÍTETT ÉS TERMÉSZETI ÖRÖKSÉG
													</MDBBtn>
												</Link>
	                    </MDBCol>
                    </MDBRow>
                    <MDBRow center>
                      <MDBCol md="6" middle className="text-center pb-2 pt-2 pr-0">
												<Link to="/KozlekedesiAnomaliak">
													<MDBBtn
															className="programok-btn-landing"
															type="btn"
															>
															A KÖZLEKEDÉSI ANOMÁLIÁK FELOLDÁSA
													</MDBBtn>
												</Link>
                      </MDBCol>
											<MDBCol md="6" middle className="text-center pb-2 pt-2 pl-0">
												<Link to="/PenzugyiForrasok">
													<MDBBtn
															className="programok-btn-landing"
															type="btn"
															>
															A PÉNZÜGYI FORRÁSOKRÓL
													</MDBBtn>
												</Link>
											</MDBCol>
                    </MDBRow>
										<MDBRow center>
											<MDBCol md="3" middle className="text-center pb-3 pt-2">

											</MDBCol>
											<MDBCol md="6" middle className="text-center pb-3 pt-2">
												<Link to="/MeltoIdoskor">
													<MDBBtn
															className="programok-btn-landing"
															type="btn"
															>
															MÉLTÓ IDŐSKORT
													</MDBBtn>
												</Link>
											</MDBCol>
											<MDBCol md="3" middle className="text-center pb-3 pt-2">

											</MDBCol>
                    </MDBRow>
	                  </MDBCol>
	                  <MDBCol md="7" lg="7" className="pr-3">
	                    <MDBRow className="left-padding-row top-padding-first-row">
	                      <MDBCol md="12" lg="12" className="text-left">
	                        <span className="tisztesseg-elszants text-uppercase">Tisztesség. Elszántság. Együttműködés.</span>
	                      </MDBCol>
	                    </MDBRow>
	                    <MDBRow className="left-padding-row top-padding-another-row">
	                      <MDBCol middle md="2" lg="3" className="text-center">
	                        <img className="icon-landing-size" src={kepviselo}></img>
	                      </MDBCol>
	                      <MDBCol md="10" lg="9" className="text-left">
	                        <p className="kampany-title">Jelenleg is Önt képviselem</p>
	                        <span className="kampany-text">a megyei közgyűlésben, az ellenzéki frakciót vezetem. Az Európai Unió Régiók Bizottságának munkájában magyar delegáltként környezetvédelemmel foglalkozom.</span>
	                      </MDBCol>
	                    </MDBRow>
	                    <MDBRow className="left-padding-row top-padding-another-row">
	                      <MDBCol middle md="2" lg="3" className="text-center">
	                        <img className="icon-landing-size" src={jogasz}></img>
	                      </MDBCol>
	                      <MDBCol md="10" lg="9" className="text-left">
	                        <p className="kampany-title">Jogászként és közgazdászként</p>
	                        <span className="kampany-text">nemzetközi vállalatoknál szereztem tapasztalatot a mobiltelefon-iparban, az autóiparban és a telekommunikációban.</span>
	                      </MDBCol>
	                    </MDBRow>
	                    <MDBRow className="left-padding-row top-padding-another-row">
	                      <MDBCol middle md="2" lg="3" className="text-center">
	                        <img className="icon-landing-size" src={csalad}></img>
	                      </MDBCol>
	                      <MDBCol md="10" lg="9" className="text-left">
	                        <p className="kampany-title">Kisgyermekes apaként</p>
	                        <span className="kampany-text">Vértesszőlősön élek családommal. Komárom-Esztergom megye születésem óta az otthonom.</span>
	                      </MDBCol>
	                    </MDBRow>
	                  </MDBCol>
	                </MDBRow>
								</div>
							</MDBContainer>
		          <MDBContainer fluid className="section fluid-container">
		            <div className={styles.bodywrapper3}>
	                <MDBRow className="m-0">
	                  <MDBCol md="6" lg="6" className="p-0">
	                    <MDBRow>
	                      <img className="asset2-size" src={asset2}></img>
	                    </MDBRow>
	                    <MDBRow>
	                      <MDBCol md="5" lg="5">
	                      </MDBCol>
	                      <MDBCol md="7" lg="7">
	                        <a href="https://www.facebook.com/drkonczererik" target="_blank" rel="noopener noreferrer">
	                          <MDBRow start>
	                            <MDBCol middle md="2" className="px-0 py-4 text-center">
	                              <img className="social-icon" src={facebook}></img>
	                            </MDBCol>
	                            <MDBCol middle md="10" className="px-0 py-4">
	                              <span className="social-text">drkonczererik</span>
	                            </MDBCol>
	                          </MDBRow>
	                        </a>
	                        <a href="https://www.instagram.com/konczererik/" target="_blank" rel="noopener noreferrer">
	                          <MDBRow start>
	                            <MDBCol middle md="2" lg="2" className="px-0 py-4 text-center">
	                              <img className="social-icon" src={instagram}></img>
	                            </MDBCol>
	                            <MDBCol middle md="10" lg="10" className="px-0 py-4">
	                              <span className="social-text">@konczererik</span>
	                            </MDBCol>
	                          </MDBRow>
	                        </a>
	                        <a href="https://twitter.com/erikkonczer" target="_blank" rel="noopener noreferrer">
	                          <MDBRow start>
	                            <MDBCol middle md="2" lg="2" className="px-0 py-4 text-center">
	                              <img className="social-icon" src={twitter}></img>
	                            </MDBCol>
	                            <MDBCol middle md="10" lg="10" className="px-0 py-4">
	                              <span className="social-text">@erikkonczer</span>
	                            </MDBCol>
	                          </MDBRow>
	                        </a>
	                       {/* <a href="" target="_blank" rel="noopener noreferrer">
	                          <MDBRow start>
	                            <MDBCol middle md="2" lg="2" className="px-0 py-4 text-center">
	                              <img className="social-icon" src={tiktok}></img>
	                            </MDBCol>
	                            <MDBCol middle md="10" lg="10" className="px-0 py-4">
	                              <span className="social-text">@konczererik</span>
	                            </MDBCol>
	                          </MDBRow>
	                        </a>*/}
	                      </MDBCol>
	                    </MDBRow>
	                  </MDBCol>
	                  <MDBCol middle md="6" lg="6" className="pt-5" >
										{ browserName === "Safari" || browserName === "Mobile Safari" ?
											<FacebookProvider appId="932783620829084">
												<Page href="https://www.facebook.com/drkonczererik"
															tabs="timeline"
															width={parseInt(window.outerWidth*0.4) < 500 ? parseInt(window.outerWidth*0.4) : 500}
															height="700" />
											</FacebookProvider>
										:
													<iframe src={"https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com/%2Fdrkonczererik&tabs=timeline&width=" + parseInt(window.outerWidth*0.4) + "&height=650&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=false&appId"}
																	width={parseInt(window.outerWidth*0.4) < 500 ? parseInt(window.outerWidth*0.4) : 500}
																	height="700"
																	style={{border: "none",overflow: "hidden"}}
																	scrolling="no"
																	frameborder="0"
																	allowfullscreen="true"
																	allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
										}
																	{/*<img className="konczer-facebook-img" src={konczer_facebook}></img>*/}
	                  </MDBCol>
									</MDBRow>
									<div className="fixed-bottom-landing">
										<Footer/>
									</div>
		            </div>
		          </MDBContainer>
		        </ReactFullpage.Wrapper>
					</>
	      	);
	    	}}
		  />

		</>
    );
  }
}
export default  LandingPageDesktop;
